import SitePages from "../../components/admin/SitePages";

export default function SitePagesPage() {
  return <SitePages />;
}
